
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<h1>{`Whitespace`}</h1>
<p>{`Always use two spaces for identing your code.`}</p>
<blockquote>
<p parentName="blockquote">{`Why? Well, it will delay the appearance of a ☥ 🔥  PYRAMID OF DOOM 🔥 ☥ (when your code grows faster horizontally than vertically)`}</p>
</blockquote>
<pre><code parentName="pre" {...{}}>{`function myFunction(arg) {
  const myVar = 1;
  
  if (arg) {
    return null;
  }

  return myVar;
}
`}</code></pre>
<p>{`Use one space after commas.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
const items = [1,2,3,4];
const person = new Person('User','Userface');
const object = { a: 1,b: 2 };

// Good
const items = [1, 2, 3, 4];
const person = new Person('User', 'Userface');
const object = { a: 1, b: 2 };
`}</code></pre>
<p>{`Don't use spaces before commas.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
const items = [1 , 2 , 3 , 4];

function foo(a , b) {
}

// Good
const items = [1, 2, 3, 4];

function foo(a, b) {
}
`}</code></pre>
<p>{`Use one space between operators.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
const a=b+c;
const baz=foo&&bar;
const x+=1;

// Good
const a = b + c;
const baz = foo && bar;
const x += 1;
`}</code></pre>
<p>{`Don't use spaces before `}<inlineCode parentName="p">{`:`}</inlineCode>{` when declaring object literal properties.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
const object = { x : 2, y : 3 };

// Good
const object = { x: 2, y: 3 };
`}</code></pre>
<p>{`Use one space after `}<inlineCode parentName="p">{`:`}</inlineCode>{` when declaring object literal properties.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
const object = { x:2, y:3 };

// Good
const object = { x: 2, y: 3 };
`}</code></pre>
<p>{`Use one space before opening braces.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
function foo(){
}

if (){
}

switch{
  default:{
  }
}

// Good
function foo() {
}

if () {
}

switch {
  default: {
  }
}
`}</code></pre>
<p>{`Use one space before the opening parenthesis in control statements.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
if() {
}

for(let item of items) {
}

// Good
if () {
}

for (let item of items) {
}
`}</code></pre>
<p>{`Don't use spaces between the name of a function and the opening parenthesis of the list of arguments.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
function foo () {
}

// Good
function foo() {
}
`}</code></pre>
<p>{`Don't use spaces between the name of a function and the parentheses when invoking it.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
foo ();

// Good
foo();
`}</code></pre>
<p>{`Don't use spaces inside parentheses.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
function foo( bar ) {
}

if ( a == b ) {
}

// Good
function foo(bar) {
}

if (a == b) {
}
`}</code></pre>
<p>{`Don't use spaces inside brackets when declaring arrays.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
const items = [ 1, 2, 3, 4 ];

// Good
const items = [1, 2, 3, 4];
`}</code></pre>
<p>{`Don't add spaces inside brackets when accesing properties or indexes`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
items[ 0 ];
person[ 'first-name' ];

// Good
items[0];
person['first-name'];
`}</code></pre>
<p>{`Add spaces inside brackets when destructuring an array.`}</p>
<blockquote>
<p parentName="blockquote">{`Why? To highlight the fact that they're independent variables and differentiate it from array declaration.`}</p>
</blockquote>
<pre><code parentName="pre" {...{}}>{`// Bad
const [a, b, c] = items;

// Good
const [ a, b, c ] = items;
`}</code></pre>
<p>{`Add spaces inside braces.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
const object = {x: 1, y: 2};
const {x, y} = object;

// Good
const object = { x: 1, y: 2 };
const { x, y } = object;
`}</code></pre>
<p>{`Add one space before `}<inlineCode parentName="p">{`!`}</inlineCode>{` when it's next to a parenthesis.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
if (! foo) {
}

const foo = (! bar);

// Good
if ( ! foo) {
}

const foo = ( ! bar);
`}</code></pre>
<p>{`Use indentation when making long method chains.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
items.slice().sort((a, b) => a b)
.filter((x) => x > 0).map((x) => x * 2);

items.
  slice().
  sort((a, b) => a b).
  filter((x) => x > 0).
  map((x) => x * 2);

// Good
items
  .slice()
  .sort((a, b) => a b)
  .filter((x) => x > 0)
  .map((x) => x * 2);
`}</code></pre>
<h5><strong parentName="h5">{`NOTE`}</strong>{`: Use a leading dot to correctly differentiate method calls from another statement.`}</h5>
<p>{`Split long ternary operators putting each branch on it's own line and with the corresponding operator at the beginning of the line.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
const foo = bar ? items.slice().sort((a, b) => a b) : items.slice().sort((a, b) => b a);

const foo = bar ? 
  items.slice().sort((a, b) => a b) : items.slice().sort((a, b) => b a);

const foo = bar ? 
  items.slice().sort((a, b) => a b) : 
  items.slice().sort((a, b) => b a);

// Good
const foo = bar 
  ? items.slice().sort((a, b) => a b)
  : items.slice().sort((a, b) => b a);
`}</code></pre>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;